import {Component, OnInit} from '@angular/core';
import {
  AlertController,
  IonRouterOutlet,
  LoadingController,
  ModalController,
  NavController,
  ToastController
} from "@ionic/angular";
import {ActivatedRoute} from "@angular/router";
import {ServerService} from "../service/server.service";
import {AdminService} from "../service/admin.service";
import {CinfoPage} from "../cinfo/cinfo.page";
import {ProfileAddPage} from "./profile-add/profile-add.page";
import {Constant} from "../shared/model/Constant";
import {ManageModulesComponent} from "./manage-modules/manage-modules.component";
import {SearchUtil} from "../shared/utils/SearchUtil";
import {UserEditPage} from "../users/user-edit/user-edit.page";
import {ProfileEditPage} from "./profile-edit/profile-edit.page";

@Component({
  selector: 'app-profile',
  templateUrl: './profile.page.html',
  styleUrls: ['./profile.page.scss'],
})
export class ProfilePage implements OnInit {

  data: any;
  user: any;
  q: any;
  text: any;
  profiles: any[];
  profilesFiltered: any[];

  constructor(private routerOutlet: IonRouterOutlet,
              public modalController: ModalController,
              public alertController: AlertController,
              private route: ActivatedRoute,
              public server: ServerService,
              public toastController: ToastController,
              private nav: NavController,
              public loadingController: LoadingController,
              private adminService: AdminService) {

    this.user = JSON.parse(localStorage.getItem(Constant.userData));
    this.text = JSON.parse(localStorage.getItem(Constant.appText));

  }

  ngOnInit() {
    this.ionViewDidEnter();
  }

  ionViewDidEnter() {
    this.loadData();
  }

  async loadData() {
    const loading = await this.loadingController.create({
      message: '',
      spinner: 'bubbles',
      duration: 3000
    });
    await loading.present();
    this.adminService.getAllProfile().subscribe((response: any[]) => {
      loading.dismiss();
      this.profiles = response;
    }, error => {
      console.warn("Error al consultar Perfiles", error);
      loading.dismiss();
      this.presentToast(error.error.error);
    })


    this.server.getClient().subscribe((response: any) => {
      this.data = response.data;
      loading.dismiss();
    });
  }

  async presentToast(txt) {
    const toast = await this.toastController.create({
      message: txt,
      duration: 3000,
      position: 'top',
      mode: 'ios',
      color: 'dark'
    });
    toast.present();
  }

  async presentAlert(id) {
    const alert = await this.alertController.create({
      header: this.text.are_you_sure,
      message: this.text.want_delete,
      mode: 'ios',
      buttons: [
        {
          text: this.text.cancel,
          role: 'cancel',
          handler: () => {
          }
        },
        {
          text: this.text.yes,
          role: 'confirm',
          handler: () => {
            this.remove(id)
          }
        }
      ]
    });

    await alert.present();

    const {role} = await alert.onDidDismiss();

  }

  async remove(id) {
    const loading = await this.loadingController.create({
      message: '',
      spinner: 'bubbles',
      duration: 3000
    });
    await loading.present();

    this.server.removeClient(id).subscribe((response: any) => {

      this.data = response.data;

      loading.dismiss();

    });
  }

  edit(pro) {
    localStorage.setItem(Constant.clientData, JSON.stringify(pro));

    this.nav.navigateForward('/client-add/' + pro.id);

  }

  async view(client) {
    const modal = await this.modalController.create({
      component: CinfoPage,
      animated: true,
      mode: 'ios',
      cssClass: 'my-custom-modal-css',
      backdropDismiss: true,
      swipeToClose: true,
      breakpoints: [0, 0.3, 0.5, 0.5],
      initialBreakpoint: 0.5,
      componentProps: {

        'data': client,
      }

    });

    modal.onDidDismiss().then(data => {

      if (data.data.notes) {
      }

    })

    return await modal.present();
  }

  async addProfile(data = []) {
    const modal = await this.modalController.create({
      component: ProfileAddPage,
      animated: true,
      mode: 'ios',
      cssClass: 'my-custom-modal-css',
      backdropDismiss: true,
      swipeToClose: true,
      componentProps: {
        'data': data,
      }
    });

    modal.onDidDismiss().then(data => {
      if (data) {
        this.loadData();
      }
    })

    return await modal.present();
  }


  onChangePage(event: any) {
    this.profilesFiltered = event; //this.pageOfItems = pageOfItems;
  }


  async deleteProfile(profileId: any) {
    const alert = await this.alertController.create({
      header: 'Estas Seguro',
      message: 'Esta accion no se puede reversar',
      mode: 'ios',
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          handler: () => {
          },
        },
        {
          text: 'Eliminar',
          role: 'confirm',
          handler: () => {
            this.adminService.deleteProfile(profileId).subscribe((response: any) => {
              this.presentToast('Perfil eliminado con éxito');
              this.loadData();
            }, error => {
              console.warn(error)
              this.presentToast(error.error.error);
            });
          },
        },
      ],
    });

    await alert.present();
  }

  async manageModules(profile: any) {
    const modal = await this.modalController.create({
      component: ManageModulesComponent,
      animated: true,
      mode: 'ios',
      cssClass: 'my-custom-modal-css',
      backdropDismiss: true,
      swipeToClose: true,
      componentProps: {
        profile,
      }
    });
    modal.onDidDismiss().then(data => {
      if (data) {
      }
    });
    return await modal.present();
  }

  search(event: any) {
    if (event && event.detail && event.detail.value) {
      const result = SearchUtil.findMatchingPositions(this.profiles, event.detail.value);
      this.profilesFiltered = result;
    }
    if (event.detail.value === '') {
      this.profilesFiltered = this.profiles;
    }
  }

 async editProfile(user: any) {
    const modal = await this.modalController.create({
      component: ProfileEditPage,
      animated: true,
      mode: 'ios',
      cssClass: 'my-custom-modal-css',
      backdropDismiss: true,
      swipeToClose: true,
      componentProps: {
        user,
      }
    });
    modal.onDidDismiss().then(data => {
      if (data) {
        //this.loadData();
      }
    });
    return await modal.present();
  }
}
